import { 
  Box, 
  Divider, 
  Grid, 
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  tableContainer: {
    boxShadow: "none", // Remove border and shadow from the container
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    padding: "16px", // Standard padding for consistency
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
  root: {
    marginTop: "1em",
    backgroundColor: "#E8F3F8", // Light blue background
    padding: theme.spacing(2),
    borderRadius: "4px",
    display: "flex", // Use flexbox for the root
    alignItems: "stretch", // Vertically center content
  },
  header: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
  },
  divider: {
    backgroundColor: "#B0BEC5",
    height: "100%",
    width: "2px",
    margin: theme.spacing(0, 2),
  },
  rightAlign: {
    textAlign: "right",
  },
}));

export default function Ribbon({ batchDetails, targetQuantity, showRMPMDetails, row, plantAndStorageData, poDashboardBatch }) {
  const classes = useStyles();


  // Helper function to present formatted data
  const presentFormatedData = (data) => {
    if (!data || data === "" || data === null || data === undefined) {
      return "";
    }
    return data;
  };

  // Find the matching vendor data based on vendorMosymphonyID
  const getVendorPlantAndStorageData = () => {

    
    if (!plantAndStorageData || (!batchDetails?.vendorMosymphonyID && !row?.scheduleLineDetails?.vendorMosymphonyID)) {
      return { plantIDs: [], storageLocationIDs: [] };
    }
    
    const vendorID = batchDetails?.vendorMosymphonyID || row?.scheduleLineDetails?.vendorMosymphonyID;
    
    const vendorData = plantAndStorageData.find(
      item => item.vendorMosymphonyID === vendorID
    );
    
    
    return {
      plantIDs: vendorData?.receivingPlantIDs || [],
      storageLocationIDs: vendorData?.receivingStorageLocationIDs || []
    };
  };

  const { plantIDs, storageLocationIDs } = getVendorPlantAndStorageData();


  return (
    <React.Fragment>
      <Grid
        container
        justifyContent="flex-start"
        style={{ backgroundColor: "#c2e1ef" }}
      >
        <Grid item>
          <TableContainer
            component={Paper}
            className={classes.tableContainer}
          >
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Sponsor Name
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    CMO
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Product Code / Description
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Batch Number
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Batch Size
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    UOM
                  </TableCell>
                  {showRMPMDetails && (
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO Number
                    </TableCell>
                  )}
                  {!showRMPMDetails && (
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO - Line
                    </TableCell>
                  )}
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Plant ID
                  </TableCell>
                  <TableCell
                    className={`${classes.tableCell} ${classes.headerCell}`}
                  >
                    Storage Location ID
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      batchDetails?.sponsorOrgName || 
                      row?.scheduleLineDetails?.sponsorName)}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      batchDetails?.cmoMember || 
                      row?.scheduleLineDetails?.vendorName ||
                      row?.scheduleLineDetails?.cmoName
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      `${batchDetails?.fgMaterialCode || row?.scheduleLineDetails?.fgMaterialCode || ""} / ${
                        batchDetails?.fgMaterialName || row?.scheduleLineDetails?.fgMaterialName || ""
                      }`
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      batchDetails?.vendorBatchNumber || 
                      row?.batchDetails?.vendorBatchNumber
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      batchDetails?.batchSize || 
                      row?.batchDetails?.batchSize
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {presentFormatedData(
                      batchDetails?.batchUOM || 
                      row?.batchDetails?.batchUOM
                    )}
                  </TableCell>
                  {showRMPMDetails && (
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.scheduleAgreementNumber || 
                        row?.scheduleLineDetails?.scheduleAgreementNumber
                      )}
                    </TableCell>
                  )}
                  {!showRMPMDetails && (
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        (() => {
                          const poNumber = batchDetails?.scheduleAgreementNumber || row?.scheduleLineDetails?.scheduleAgreementNumber;
                          const lineNumber = batchDetails?.scheduleLineItemNumber || row?.scheduleLineDetails?.scheduleLineItemNumber;
                          return (poNumber && lineNumber) ? `${poNumber} - ${lineNumber}` : '';
                        })()
                      )}
                    </TableCell>
                  )}
                  <TableCell className={classes.tableCell2}>
                    {/* {presentFormatedData(
                      plantIDs.length > 0 ? plantIDs.join(', ') : 
                      row?.scheduleLineDetails?.vendorPlant || 'NA'
                    )} */}
                    {
                      presentFormatedData((!poDashboardBatch ? (batchDetails?.vendorPlant ?? '') : (row?.scheduleLineDetails?.vendorPlant ?? '')))
                    }
                  </TableCell>
                  <TableCell className={classes.tableCell2}>
                    {/* {presentFormatedData(
                      storageLocationIDs.length > 0 ? storageLocationIDs.join(', ') : 
                      row?.scheduleLineDetails?.storageLocation || 'NA'
                    )} */}
                    {
                      presentFormatedData((!poDashboardBatch ? (batchDetails?.storageLocation ?? '') : (row?.scheduleLineDetails?.storageLocation ?? '')))
                    }
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
